// WorkerSitesBarChart.jsx
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./WorkersAnalytics.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Customized,
  ComposedChart,
  Rectangle,
} from "recharts";
import {updateIsWorkersAnalyticsPageOpen} from "../../../redux/reducers/fieldMembers";

const WorkersAnalytics = () => {
  const isWorkersAnalyticsPageOpen = useSelector(
    (state) => state.fieldMembers.isWorkersAnalyticsPageOpen
  );
  const tableData = useSelector((state) => state.fieldMembers.data);
  const zones = useSelector((state) => state.zones);
  const workerAssignedSitesCount = useSelector(
    (state) => state.markerCoordinates.workerAssignedSitesCount
  );

  const dispatch = useDispatch();

  // ✅ Define this BEFORE using it below
  const getCompletedSites = (row) => {
    return workerAssignedSitesCount[row.employee_id] !== undefined
      ? workerAssignedSitesCount[row.employee_id] - row.num_active_sites
      : row.num_active_sites;
  };

  const chartData = tableData
    .filter((data) => zones.selected[data.zone]) // Only include selected zones
    .map((data) => ({
      name: `${data.first_name} --${data.employee_id}`,
      ActiveSites: data.num_active_sites,
      CompletedSites: getCompletedSites(data),
    }));

  const handleClick = () => {
    dispatch(updateIsWorkersAnalyticsPageOpen(!isWorkersAnalyticsPageOpen));
  };

  //   return (
  //     <div className="analytics-box-container">
  //       <div className="bar-graph">
  //         <ResponsiveContainer>
  //           <BarChart
  //             data={chartData}
  //             margin={{
  //               top: 20,
  //               right: 30,
  //               left: 0,
  //               bottom: 5,
  //             }}
  //           >
  //             <CartesianGrid strokeDasharray="3 3" />
  //             <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
  //             <YAxis />
  //             <Tooltip />
  //             <Legend />
  //             <Bar dataKey="ActiveSites" fill="#8884d8" />
  //             <Bar dataKey="CompletedSites" fill="#82ca9d" />
  //           </BarChart>
  //         </ResponsiveContainer>
  //       </div>
  //     </div>
  //   );
  //   return (
  //     <div className="analytics-box-container">
  //       {/* Bar Graph */}
  //       <div className="bar-graph">
  //         <ResponsiveContainer>
  //           <BarChart
  //             data={chartData}
  //             margin={{
  //               top: 20,
  //               right: 30,
  //               left: 0,
  //               bottom: 5,
  //             }}
  //           >
  //             <CartesianGrid strokeDasharray="3 3" />
  //             <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
  //             <YAxis />
  //             <Tooltip />
  //             <Legend />
  //             <Bar dataKey="ActiveSites" fill="#8884d8" />
  //             <Bar dataKey="CompletedSites" fill="#82ca9d" />
  //           </BarChart>
  //         </ResponsiveContainer>
  //       </div>

  //       {/* Simulated Box Plot Below */}
  //       <div className="box-plot">
  //         <ResponsiveContainer>
  //           <BarChart
  //             data={chartData.map((d) => {
  //               const total = d.CompletedSites + d.ActiveSites;
  //               const completedPercent =
  //                 total > 0 ? (d.CompletedSites / total) * 100 : 0;
  //               const activePercent =
  //                 total > 0 ? (d.ActiveSites / total) * 100 : 0;
  //               return {
  //                 name: d.name,
  //                 Completed: completedPercent,
  //                 Active: activePercent,
  //               };
  //             })}
  //             margin={{
  //               top: 20,
  //               right: 30,
  //               left: 0,
  //               bottom: 5,
  //             }}
  //           >
  //             <CartesianGrid strokeDasharray="3 3" />
  //             <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
  //             <YAxis unit="%" />
  //             <Tooltip />
  //             <Legend />
  //             <Bar dataKey="Completed" stackId="a" fill="#82ca9d" />
  //             <Bar dataKey="Active" stackId="a" fill="#ff6b6b" />
  //           </BarChart>
  //         </ResponsiveContainer>
  //       </div>
  //     </div>
  //   );
  return (
    <div className="analytics-box-container">
      {/* Go Back Button */}
      <div className="go-back-wrapper">
        <button
          className="go-back-button"
          onClick={handleClick}
        >
          ⬅ Go Back
        </button>
      </div>
      {/* Worker Sites Bar Graph */}
      <div className="analytics-section">
        <h2 className="section-heading">📊 Worker Site Status Overview</h2>
        <p className="section-subtext">
          Number of active and completed sites assigned to each worker
        </p>
        <div className="bar-graph graph-card">
          <ResponsiveContainer>
            <BarChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="ActiveSites" fill="#8884d8" />
              <Bar dataKey="CompletedSites" fill="#82ca9d" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Worker Completion Ratio Bar */}
      <div className="analytics-section">
        <h2 className="section-heading">📊 Worker Efficiency (Completion %)</h2>
        <p className="section-subtext">
          Percentage of completed vs active sites per worker
        </p>
        <div className="box-plot graph-card">
          <ResponsiveContainer>
            <BarChart
              data={chartData.map((d) => {
                const total = d.CompletedSites + d.ActiveSites;
                const completedPercent =
                  total > 0 ? (d.CompletedSites / total) * 100 : 0;
                const activePercent =
                  total > 0 ? (d.ActiveSites / total) * 100 : 0;
                return {
                  name: d.name,
                  Completed: completedPercent,
                  Active: activePercent,
                };
              })}
              margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} />
              <YAxis unit="%" />
              <Tooltip />
              <Legend />
              <Bar dataKey="Completed" stackId="a" fill="#82ca9d" />
              <Bar dataKey="Active" stackId="a" fill="#ff6b6b" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default WorkersAnalytics;
